import React, { useEffect, useState } from "react";
import "./index.scss";
import CloseIcon from "react-icons/lib/md/close";
import faqData, { getFaqData } from "./faqData";
import { useTranslation } from "react-i18next";
// import Resources from "./Resources";

export default function FAQModal(props) {
  const { selectedFaq } = props;

  const [expanded, setExpanded] = useState(true);
  const {t} = useTranslation("review_activity")


  if (!selectedFaq) return null;

  const faqData = getFaqData(t);
  const selectedFaqData = faqData[selectedFaq];

  if(!selectedFaqData) return null;
  
  const {Content} = selectedFaqData;

  return (
    <div onClick={onClose} className="faqmodal-backdrop">
      <div onClick={(e) => e.stopPropagation()} className="faqmodal-card">
        <div className="faqmodal-faqname">
          <div>{selectedFaqData.title }</div>
          <CloseIcon className="faqmodal-xicon" onClick={onClose} />
        </div>
        <div className="faqmodal-faqsarea">
          <Content/>
          </div>
        {/* <ResourcesModal /> */}
      </div>
    </div>
  );

  function onClose() {
    props.setSelectedFaq(null);
    setExpanded(false);
  }

  // function faqsmodal() {
  //   return (
  //     <div>
  //       <CloseIcon className="faqmodal-xicon" onClick={onClose} />
  //       <div className="faqmodal-header">Resources</div>
  //       <Resources
  //         resources={resources}
  //         expanded={expanded}
  //         setExpanded={setExpanded}
  //       />
  //     </div>
  //   );
  // }
}
